import { QRMTableSlice } from '.'
import { AppDispatch, store } from '../../index'
import { TableStatuses } from './types'
import { ToastsSlice } from '../ToasterReducer'
import { qrMenuGET } from 'featureSliced/shared/api/qrMenu/GET'

export const loadTableStatus =
  (tableIdParam?: string | number, lastStepCallback?: () => void) =>
  async (dispatch: AppDispatch) => {
    const paymentVariant = store.getState().app.menu.paymentVariant
    if (paymentVariant === 2) {
      try {
        const isTableLoading = store.getState().qrMenuTable.isTableLoading
        const params = new URLSearchParams(document.location.search)
        const table = params.get('table') || tableIdParam
        if (table && !isTableLoading) {
          dispatch(QRMTableSlice.actions.setIsTableLoading(true))
          const paymentData = await qrMenuGET.cloudOrders(table)
          const items = paymentData?.storageItem?.tableOrder?.items?.filter(
            (el) => !el.isRemoved
          )
          const tableIdRes = paymentData?.storageItem?.tableOrder?.tableId
          const modVer = paymentData?.storageItem?.tableOrder?.modVer
          const orderGuid = paymentData?.storageItem?.tableOrder?.orderGuid

          const tableStatus = items?.length
            ? TableStatuses.IN_USE
            : TableStatuses.FREE
          // openTableToast(dispatch, tableStatus)
          dispatch(QRMTableSlice.actions.setTableStatus(tableStatus))
          dispatch(QRMTableSlice.actions.setCloudItems(items || []))
          dispatch(QRMTableSlice.actions.setModVer(modVer || 0))
          dispatch(QRMTableSlice.actions.setOrderGuid(orderGuid))
          dispatch(QRMTableSlice.actions.setTableId(table || tableIdRes || 0))
          dispatch(
            QRMTableSlice.actions.setCloudTotal(
              paymentData?.storageItem?.tableOrder?.total || 0
            )
          )
          return tableStatus
        }
      } catch (e) {
        // openTableToast(dispatch, TableStatuses.BUSY)
        dispatch(QRMTableSlice.actions.setTableStatus(TableStatuses.BUSY))
        return TableStatuses.BUSY
      } finally {
        dispatch(QRMTableSlice.actions.setIsTableDataLoaded())
        lastStepCallback?.()
      }
    } else if (paymentVariant === 1) {
      dispatch(QRMTableSlice.actions.setTableStatus(TableStatuses.FREE))
      dispatch(QRMTableSlice.actions.setIsTableDataLoaded())
      return TableStatuses.FREE
    } else {
      dispatch(QRMTableSlice.actions.setIsTableDataLoaded())
      return TableStatuses.BUSY
    }
  }
